import { grey } from "@mui/material/colors";

const styles = {
  mainContainer: {
    backgroundColor: 'white', 
    borderRadius: '1rem', 
    width: '100%', 
    padding: '0px 20px', 
    marginBottom: '12px', 
    display: 'flex',
    justifyContent: 'start',
  },
  title: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: grey[700],
  }
};

export default styles;